export enum Store {
  AppStore = 'appStore',
  GooglePlay = 'googlePlay',
  GetApps = 'getApps',
  AppGallery = 'appGallery',
  GalaxyStore = 'galaxyStore',
  Apk = 'apk',
  RuStore = 'ruStore',
}
